import { Space, Tag } from 'antd'
import { StakingTokenConfigItem, StakingTokenConfigPoolType } from 'Modules'

import ProtectedButton from 'component/button/protected-button'
import { FEATURE } from 'constants/feature'

interface ConfigRowProps {
  pool: StakingTokenConfigPoolType
  config: StakingTokenConfigItem
  onEdit: (pool: StakingTokenConfigPoolType, config: StakingTokenConfigItem) => void
  onDelete: (config: StakingTokenConfigItem) => void
}

const ConfigRow = ({ pool, config, onEdit, onDelete }: ConfigRowProps) => {
  return (
    <div className="config-row">
      <div className="config-row__cell config-row__cell--name">
        <span className="config-row__label">Name</span>
        <span className="config-row__value">{config.name}</span>
      </div>
      <div className="config-row__cell">
        <span className="config-row__label">Value</span>
        <span className="config-row__value">{config.value}</span>
      </div>
      <div className="config-row__cell">
        <span className="config-row__label">Status</span>
        <Tag color={config.isActive ? 'green' : 'red'}>
          {config.isActive ? 'Active' : 'Inactive'}
        </Tag>
      </div>
      <div className="config-row__actions">
        <Space>
          <ProtectedButton
            color="primary"
            variant="solid"
            feature={FEATURE.SETTING}
            requireCRUD
            onClick={() => onEdit(pool, config)}
          >
            Edit
          </ProtectedButton>
          <ProtectedButton
            color="danger"
            variant="solid"
            feature={FEATURE.SETTING}
            requireCRUD
            onClick={() => onDelete(config)}
          >
            Delete
          </ProtectedButton>
        </Space>
      </div>
    </div>
  )
}

interface ExpandedConfigListProps {
  pool: StakingTokenConfigPoolType
  onEdit: (pool: StakingTokenConfigPoolType, config: StakingTokenConfigItem) => void
  onDelete: (config: StakingTokenConfigItem) => void
}

const ExpandedConfigList = ({ pool, onEdit, onDelete }: ExpandedConfigListProps) => {
  return (
    <div className="config-list">
      {pool.configs.map((config) => (
        <ConfigRow
          key={config._id}
          pool={pool}
          config={config}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  )
}

export default ExpandedConfigList
